// Copyright (c) StrangeBee 2023

import { Route as DashboardDetailsRoute } from './Details';
import { Route as DashboardHomeRoute } from './List';

export const Routes = [DashboardDetailsRoute, DashboardHomeRoute];
